import { prefixerT } from '.'

export const ROUTE_APROBACION_PROVEEDOR = prefixerT('aprobacion-proveedor')
